import { routes } from 'commons/constants/routes'
import { Customer } from 'commons/types/DTO/bank/companyDetails/customer'
import { IconName, IconSize } from 'ui/components/Icon'
import { Link } from 'ui/components/Link'
import { TableColumn } from 'ui/components/Table'
import { Tooltip } from 'ui/components/Tooltip'

import * as SC from './styles'

export const columns: TableColumn<Customer>[] = [
  {
    title: 'Name',
    align: 'left',
    render: ({ id, name }) => (
      <Link to={routes.bank.customerVendors.details} params={{ id: id.toString() }}>
        <SC.CustomerName>
          {name}
          <Tooltip id={`shared-${id}`} type="dark" content="Shared" event="hover">
            <SC.WrappedIcon name={IconName.SHARED} size={IconSize.XS} />
          </Tooltip>
        </SC.CustomerName>
      </Link>
    )
  }
]
